module.exports = __webpack_public_path__ + "a440c2f8b78c487d3a4ecb45b761e802.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_variable_x1_variable/public/picture/stanley_park.jpg
// module id = 444
// module chunks = 0